export default __webpack_public_path__ + "static/media/MERN-1.8598fbdc.jpg";